import React from "react";
import {
  Grid,
  TextField,
  Typography,
  Paper,
  Switch,
  FormControlLabel,
  FormGroup,
  Button,
} from "@mui/material";
import QuestionType from "./QuestionType";

import request from "../../../../utilities/requests";

const ChoiceQuestion = ({ questionData }) => {
  const [question, setQuestion] = React.useState(questionData);
  const [changed, setChanged] = React.useState(false);

  const handleValueChange = (field, value) => {
    question[field] = value;
    setQuestion({ ...question });
    setChanged(true);
  };

  const handleSave = async () => {
    const result = await request("matchmaking/question", "post", question);
    if (result.success) {
      setChanged(false);
    }
  };

  return (
    <Grid item>
      <Paper elevation={1} style={{ padding: 10 }}>
        <Grid container direction="row" alignItems="center" spacing={2}>
          <Grid item md={6} xs={12}>
            <TextField
              value={question?.question}
              variant="standard"
              size="small"
              fullWidth
              multiline
              maxRows={3}
              style={{ paddingRight: 10 }}
              onChange={(e) => handleValueChange("question", e.target.value)}
            />
          </Grid>
          <Grid item md={3} xs={6}>
            <QuestionType label="Choice" />
          </Grid>
          <Grid item md={3} xs={6}>
            <FormControlLabel
              control={
                <Switch
                  checked={question?.active}
                  onChange={() =>
                    handleValueChange("active", !question?.active)
                  }
                />
              }
              label="Active"
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <Grid container direction="column" spacing={1}>
              <Grid item xs={12}>
                <TextField
                  value={question?.choice1}
                  helperText="Choice 1"
                  variant="standard"
                  size="small"
                  fullWidth
                  multiline
                  maxRows={3}
                  style={{ paddingRight: 10 }}
                  onChange={(e) => handleValueChange("choice1", e.target.value)}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  value={question?.choice2}
                  helperText="Choice 2"
                  variant="standard"
                  size="small"
                  fullWidth
                  multiline
                  maxRows={3}
                  style={{ paddingRight: 10 }}
                  onChange={(e) => handleValueChange("choice2", e.target.value)}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  value={question?.choice3}
                  helperText="Choice 3"
                  variant="standard"
                  size="small"
                  fullWidth
                  multiline
                  maxRows={3}
                  style={{ paddingRight: 10 }}
                  onChange={(e) => handleValueChange("choice3", e.target.value)}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  value={question?.choice4}
                  helperText="Choice 4"
                  variant="standard"
                  size="small"
                  fullWidth
                  multiline
                  maxRows={3}
                  style={{ paddingRight: 10 }}
                  onChange={(e) => handleValueChange("choice4", e.target.value)}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  value={question?.choice5}
                  helperText="Choice 5"
                  variant="standard"
                  size="small"
                  fullWidth
                  multiline
                  maxRows={3}
                  style={{ paddingRight: 10 }}
                  onChange={(e) => handleValueChange("choice5", e.target.value)}
                />
              </Grid>
            </Grid>
          </Grid>
          {changed ? (
            <Grid item xs={12}>
              <Button variant="contained" onClick={handleSave}>
                Save
              </Button>
            </Grid>
          ) : (
            <></>
          )}
        </Grid>
      </Paper>
    </Grid>
  );
};

export default ChoiceQuestion;
